import { render, staticRenderFns } from "./FeedContentBody.vue?vue&type=template&id=1fede347&"
import script from "./FeedContentBody.vue?vue&type=script&lang=ts&"
export * from "./FeedContentBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports